// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__7Zos_","ant-tooltip-open":"Slider_ant-tooltip-open__Ax9e1"};